import Vue from "vue";
import Vuetify from "vuetify/lib";
import { UserVuetifyPreset } from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
import AiSearchIcon from "@/components/icons/AiSearchIcon.vue";

Vue.use(Vuetify);

const customIcons = {
    ai_assistant: {
        component: AiSearchIcon
    }
};

const opts: Partial<UserVuetifyPreset> = {
    icons: {
        iconfont: "mdi",
        values: {
            ...customIcons
        }
    },
    theme: {
        options: {
            customProperties: true,
            variations: true
        }
    }
};
export default new Vuetify(opts);
